import * as React from 'react';

import {Popover} from 'shells/popover/popover';

import type {HeaderFieldType, View, ImageFieldType, SelectFieldInput} from '../../../../types';

import {FieldCards} from './field-cards';
import {HeaderCards} from './header-cards';
import {MoreFieldsButton} from './more-fields-button';

import styles from './add-card.module.css';

type Props = {
    hasNameField: boolean;
    hasFirstNameField: boolean;
    hasLastNameField: boolean;
    hasCompanyNameField: boolean;
    onSelectInputField: (arg1: SelectFieldInput) => void;
    onSelectHeaderField: (arg1: HeaderFieldType | ImageFieldType) => void;
    setCurrentView: (newView: View) => void;
};

export function StandardBlocks(props: Props) {
    const [popoverAnchor, setPopoverAnchor] = React.useState<any>(null);
    const [popoverContent, setPopoverContent] = React.useState<any>(null);

    // @ts-expect-error
    const onShowPersonNamePopover = (e) => {
        setPopoverAnchor(e.target);
        setPopoverContent(
            <div>
                The <strong>name</strong>, <strong>first name</strong>, or{' '}
                <strong>last name</strong> fields have been added to your form
            </div>
        );
    };
    // @ts-expect-error
    const onShowCompanyNamePopover = (e) => {
        setPopoverAnchor(e.target);
        setPopoverContent(
            <div>
                The <strong>company name</strong> field has been added to your form
            </div>
        );
    };
    const onRemovePopover = () => {
        setPopoverAnchor(null);
        setPopoverContent(null);
    };
    const personNameIsDisabled =
        props.hasNameField || (props.hasFirstNameField && props.hasLastNameField);
    const companyNameIsDisabled = props.hasCompanyNameField;

    let nameCardFieldKey;
    let nameCardText;
    if (props.hasFirstNameField && !props.hasLastNameField) {
        nameCardFieldKey = 'lastName';
        nameCardText = 'Last name';
    } else if (props.hasLastNameField && !props.hasFirstNameField) {
        nameCardFieldKey = 'firstName';
        nameCardText = 'First name';
    } else {
        nameCardFieldKey = 'name';
        nameCardText = 'Name';
    }

    return (
        <>
            <HeaderCards onSelectHeaderField={props.onSelectHeaderField} />
            <div className={styles.divider} />
            <FieldCards
                personNameIsDisabled={personNameIsDisabled}
                companyNameIsDisabled={companyNameIsDisabled}
                onShowPersonNamePopover={onShowPersonNamePopover}
                onShowCompanyNamePopover={onShowCompanyNamePopover}
                onRemovePopover={onRemovePopover}
                nameCardText={nameCardText}
                nameCardFieldKey={nameCardFieldKey}
                onSelectInputField={props.onSelectInputField}
                setCurrentView={props.setCurrentView}
            />
            <MoreFieldsButton setCurrentView={props.setCurrentView} />
            {popoverAnchor ? (
                <Popover anchor={popoverAnchor} isDialog={true}>
                    {popoverContent}
                </Popover>
            ) : undefined}
        </>
    );
}
